// extracted by mini-css-extract-plugin
module.exports = {"doughnut-chart":"doughnutchart_doughnut-chart__23Png","doughnut-chart__wrapper":"doughnutchart_doughnut-chart__wrapper__1umcB"};